import { c as _c } from "react/compiler-runtime";
import Grid from '@mui/material/Grid';
import { useReviewContext } from 'src/app/credit-cards/reviews/components/Context';
import ApplyNowButton from './ApplyNowButton';
import RatesAndFeesButton from './RatesAndFeesButton';
export default function SidebarProductCardApplyNowContainer() {
  const $ = _c(2);
  const {
    marketplaceEntity: t0
  } = useReviewContext();
  const {
    showCTA
  } = t0;
  let t1;
  if ($[0] !== showCTA) {
    t1 = showCTA ? <Grid textAlign="center" width="100%"><ApplyNowButton /><RatesAndFeesButton /></Grid> : null;
    $[0] = showCTA;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}